import { accountTypes } from 'src/constantsMessage';
import moment from 'moment';
export const percentageFormate = value => {};

export const encode64Base = (data, isString) => {
  let objJsonStr = JSON.stringify(data);
  let objJsonB64 = isString
    ? Buffer.from(data).toString('base64')
    : Buffer.from(objJsonStr).toString('base64');
  return objJsonB64;
};

export const formDataToencode64Base = data => {
  const encodeData = encode64Base(data);
  let requestBody = { formData: encodeData };
  return requestBody;
};

export const findType = type => {
  if (type === 'OD' || type === 'OD / CC' || type === 'CC') {
    return type;
  }
  if (type === 'SA') {
    return 'Savings';
  }
  if (type === 'CA') {
    return 'Current';
  }
};

function isNumeric(value) {
  return /^-?\d+$/.test(value);
}

export const referenceIdCheck = id => {
  if (
    id.length <= 18 &&
    id.length >= 10 &&
    id.substring(0, 2) === 'PR' &&
    isNumeric(id.substring(2))
  ) {
    return '';
  }
  return id;
};

export const removeUnknownFromCounterParty = CounterParty => {
  if (CounterParty.toLowerCase() === 'unknown') {
    return '';
  }
  return CounterParty;
};

export const checkFileExtension = (fileName, onlyPDF) => {
  if (onlyPDF && /.pdf|.PDF/.test(fileName)) {
    return true;
  } else if (!onlyPDF && /.pdf|.txt|.html|.png|.jpg|.jpeg/.test(fileName)) {
    return true;
  }
  return false;
};

export const showingPagination = (page, rowsPerPage, totalCount) => {
  let pages = page + 1;
  let perPage = rowsPerPage;
  if (pages * rowsPerPage > totalCount) {
    perPage = totalCount;
  } else {
    perPage = pages * rowsPerPage;
  }
  pages = page * rowsPerPage + 1;
  return {
    pages,
    perPage
  };
};

export const getCompanyNameFromMail = mail => {
  let result = '';
  let splitMailArray = mail.split('@');
  let splitDomainNameArray = splitMailArray[1].split('.');
  if (splitDomainNameArray[0].toLowerCase() !== 'gmail') {
    for (let i = 0; i < splitDomainNameArray.length - 1; i++) {
      result += splitDomainNameArray[i];
      if (i < splitDomainNameArray.length - 2) {
        result += '.';
      }
    }
  }
  return result;
};

export const isDataAvailable = accountDetail => {
  if (
    accountDetail.accountNo !== '' &&
    accountDetail.accountType !== '' &&
    accountDetail.bankName !== '' &&
    accountDetail.accountOpeningDate &&
    accountDetail.ifscCode !== '' &&
    accountDetail.micrCode !== '' &&
    accountDetail.branchName !== '' &&
    accountDetail.branchAddress !== '' &&
    accountDetail.startDate &&
    accountDetail.endDate &&
    accountDetail.analysisStartDate &&
    accountDetail.analysisEndDate &&
    accountDetail.accountHolderName !== '' &&
    accountDetail.email !== '' &&
    accountDetail.phone !== '' &&
    accountDetail.panNumber !== ''
  ) {
    return true;
  } else {
    return false;
  }
};

export const isGstDataAvailable = values => {
  if (
    values.gstin !== '' &&
    values.customerName !== '' &&
    values.startMonth &&
    values.endMonth
  ) {
    return true;
  } else {
    return false;
  }
};

export const isBureauDataAvailable = values => {
  if (
    values.consumerName !== '' &&
    values.creditBureau !== '' &&
    values.dob &&
    values.gender
  ) {
    return true;
  } else {
    return false;
  }
};

export const getAccountTypeTilteFromAccountType = data => {
  if (data) {
    let accountTileObj = accountTypes.find(
      ele => ele.name.toUpperCase() === data.toUpperCase()
    );
    if (accountTileObj) {
      return accountTileObj.title;
    } else {
      return '-';
    }
  }
  return '';
};

export const isFilledNewReport = (values, bankList, files) => {
  const isFile = files.some(file => file && file.length !== 0) ? true : false;
  const isEntry = Object.entries(values).some(value =>
    value[0].includes('startDate') ||
    value[0].includes('endDate') ||
    value[0].includes('analysisStartDate') ||
    value[0].includes('analysisEndDate') ||
    value[0].includes('accountOpeningDate') ||
    value[0].includes('startMonth') ||
    value[0].includes('endMonth') ||
    value[0].includes('transactionStartDate') ||
    value[0].includes('transactionEndDate') ||
    value[0].includes('analysisPeriod')
      ? value[1]
      : value[1].length !== 0
  )
    ? true
    : false;
  return isEntry || isFile ? true : false;
};

export const isUpdateEditReport = (
  values,
  bankList,
  gstList,
  bureauList,
  files,
  bankAccounts,
  gstAccounts,
  bureauAccounts,
  deletedStatements,
  deletedAccountList,
  deletedLimitIds,
  reportDetail,
  deletedGstFiles,
  gstFiles
) => {
  if (Object.entries(deletedStatements).length !== 0) return true;
  if (files?.some(file => file.length !== 0)) return true;
  if (gstFiles?.some(file => file.length !== 0)) return true;
  if (deletedAccountList?.length !== 0) return true;
  if (deletedLimitIds?.length !== 0) return true;
  if (reportDetail?.report?.reportName !== values?.reportName) return true;
  if (reportDetail?.report?.reportId !== values?.referenceId) {
    if (
      !(
        referenceIdCheck(reportDetail?.report?.reportId) === '' &&
        values?.referenceId === ''
      )
    )
      return true;
  }
  let isValueChanged = false;

  isValueChanged =
    bankList && bankList.length > 0
      ? bankList.reduce((isChanged, bank, index) => {
          if (bank.accountId !== undefined) {
            const currentAccount = bankAccounts.find(
              dto => dto.account && dto.account.accountId === bank.accountId
            );
            const currentAAaccount = bankAccounts.find(
              dto =>
                dto.aaConsentDetails &&
                dto.aaConsentDetails.accountId === bank.accountId
            );
            if (!currentAccount && !currentAAaccount) {
              isChanged = true;
              return isChanged;
            }
            const type = accountTypes.find(
              type => bank.accountType && bank.accountType === type.name
            );
            if (
              currentAccount &&
              (currentAccount.account.bankId != bank.bankName.id ||
                currentAccount.account.accountNumber != bank.accountNo ||
                (type && currentAccount.account.accountType != type.id) ||
                (currentAccount.account.analysisStartDate !=
                  moment(bank.analysisStartDate).format('YYYY-MM-DD') &&
                  bank.analysisStartDate &&
                  currentAccount.account.analysisStartDate === '') ||
                (currentAccount.account.analysisStartDate !=
                  moment(bank.analysisStartDate).format('YYYY-MM-DD') &&
                  bank.analysisStartDate === null &&
                  currentAccount.account.analysisStartDate !== '') ||
                (currentAccount.account.analysisStartDate !=
                  moment(bank.analysisStartDate).format('YYYY-MM-DD') &&
                  bank.analysisStartDate !== null &&
                  currentAccount.account.analysisStartDate !== '') ||
                (currentAccount.account.analysisEndDate !=
                  moment(bank.analysisEndDate).format('YYYY-MM-DD') &&
                  bank.analysisEndDate &&
                  currentAccount.account.analysisEndDate === '') ||
                (currentAccount.account.analysisEndDate !=
                  moment(bank.analysisEndDate).format('YYYY-MM-DD') &&
                  bank.analysisEndDate === null &&
                  currentAccount.account.analysisEndDate !== '') ||
                (currentAccount.account.analysisEndDate !=
                  moment(bank.analysisEndDate).format('YYYY-MM-DD') &&
                  bank.analysisEndDate !== null &&
                  currentAccount.account.analysisEndDate !== '') ||
                (currentAccount.account.startDate !=
                  moment(bank.startDate).format('YYYY-MM-DD') &&
                  bank.startDate &&
                  currentAccount.account.startDate === '') ||
                (currentAccount.account.startDate !=
                  moment(bank.startDate).format('YYYY-MM-DD') &&
                  bank.startDate === null &&
                  currentAccount.account.startDate !== '') ||
                (currentAccount.account.endDate !=
                  moment(bank.endDate).format('YYYY-MM-DD') &&
                  bank.endDate &&
                  currentAccount.account.endDate === '') ||
                (currentAccount.account.endDate !=
                  moment(bank.endDate).format('YYYY-MM-DD') &&
                  bank.endDate === null &&
                  currentAccount.account.endDate !== '') ||
                currentAccount.account.ifscCode != bank.ifscCode ||
                currentAccount.account.micrCode != bank.micrCode ||
                currentAccount.account.branchName != bank.branchName ||
                currentAccount.account.branchAddress != bank.branchAddress ||
                currentAccount.account.accountHolderName !=
                  bank.accountHolderName ||
                currentAccount.account.jointHolderName !=
                  bank.jointHolderName ||
                currentAccount.account.email != bank.email ||
                currentAccount.account.phoneNumber != bank.phone ||
                currentAccount.account.panNumber != bank.panNumber ||
                currentAccount.account.customerAddress !=
                  bank.customerAddress ||
                (currentAccount.account.accountOpeningDate !=
                  moment(bank.accountOpeningDate).format('YYYY-MM-DD') &&
                  bank.accountOpeningDate &&
                  currentAccount.account.accountOpeningDate === '') ||
                (currentAccount.account.accountOpeningDate !=
                  moment(bank.accountOpeningDate).format('YYYY-MM-DD') &&
                  bank.accountOpeningDate === null &&
                  currentAccount.account.accountOpeningDate !== ''))
            ) {
              isChanged = true;
              return isChanged;
            }
            if (
              currentAAaccount &&
              (currentAAaccount.aaConsentDetails.customerId !==
                bank.customerId ||
                currentAAaccount.aaConsentDetails.bank !== bank.bank ||
                currentAAaccount.aaConsentDetails.dataStartDate !==
                  bank.dataStartDate ||
                currentAAaccount.aaConsentDetails.dataEndDate !==
                  bank.dataEndDate ||
                currentAAaccount.aaConsentDetails.accountNumber !==
                  bank.accountNumber ||
                currentAAaccount.aaConsentDetails.accountTypeName !==
                  bank.accountTypeName)
            ) {
              isChanged = true;
              return isChanged;
            }
            const isLimitChanged =
              currentAccount &&
              bank.sanctionLimit.reduce((isChanged, limit) => {
                const respectiveLimit =
                  currentAccount.sanctionLimits &&
                  currentAccount.sanctionLimits.find(l => l.id === limit.id);
                if (!respectiveLimit) {
                  if (
                    bank.sanctionLimit.length === 1 &&
                    limit.amount.length === 0 &&
                    !limit.startDate &&
                    !limit.endDate
                  ) {
                    isChanged = false;
                  } else {
                    isChanged = true;
                  }
                  return isChanged;
                }
                if (
                  respectiveLimit &&
                  (respectiveLimit.sanctionAmount != limit.amount ||
                    respectiveLimit.startDate !=
                      moment(limit.startDate).format('YYYY-MM-DD') ||
                    respectiveLimit.endDate !=
                      moment(limit.endDate).format('YYYY-MM-DD'))
                ) {
                  isChanged = true;
                  return isChanged;
                }
                return isChanged;
              }, false);
            if (isLimitChanged) {
              isChanged = true;
              return isChanged;
            }
            return isChanged;
          }
        }, false)
      : bureauList && bureauList.length > 0
      ? bureauList.reduce((isChanged, bank, index) => {
          if (bank.creditBureauId) {
            const currentAccount = bureauAccounts.find(
              dto => dto.cic && dto.cic.creditBureauId === bank.creditBureauId
            );
            if (!currentAccount) {
              isChanged = true;
              return isChanged;
            }

            if (
              (currentAccount &&
                currentAccount.cic &&
                currentAccount.cic.firstName !== values['firstName' + index]) ||
              currentAccount.cic.lastName !== values['lastName' + index] ||
              currentAccount.cic.middleName !== values['middleName' + index] ||
              currentAccount.cic.mobileNumber !==
                values['mobileNumber' + index] ||
              currentAccount.cic.gender !== values['gender' + index] ||
              currentAccount.cic.dob !==
                moment(values['dob' + index]).format('YYYY-MM-DD') ||
              currentAccount.cic.idType !== values['idType' + index] ||
              currentAccount.cic.idNumber !== values['idNumber' + index] ||
              currentAccount.cic.addressLine1 !==
                values['addressLine1' + index] ||
              currentAccount.cic.addressLine2 !==
                values['addressLine2' + index] ||
              currentAccount.cic.pincode !== values['pincode' + index] ||
              currentAccount.cic.state !== values['state' + index] ||
              currentAccount.cic.city !== values['city' + index] ||
              currentAccount.cic.state !== values['state' + index] ||
              currentAccount.cic.addressCategory !==
                values['addressCategory' + index]
            ) {
              isChanged = true;
            }
            return isChanged;
          }
        }, false)
      : gstList &&
        gstList.length > 0 &&
        gstList.reduce((isChanged, bank, index) => {
          if (bank.gstId) {
            const currentAccount = gstAccounts.find(
              dto => dto.gst && dto.gst.gstId === bank.gstId
            );
            if (!currentAccount) {
              isChanged = true;
              return isChanged;
            }

            if (
              currentAccount &&
              currentAccount.files.length !== 0 &&
              (currentAccount.gst.startMonthYear !==
                moment(values['startMonth' + index]).format('MM-YYYY') ||
                currentAccount.gst.endMonthYear !==
                  moment(values['endMonth' + index]).format('MM-YYYY'))
            ) {
              isChanged = true;
              return isChanged;
            }

            if (
              currentAccount.gst &&
              (currentAccount.gst.mobileNumber !== values['mobile' + index] ||
                currentAccount.gst.email !== values['email' + index])
            ) {
              return true;
            }
            return isChanged;
          }
        }, false);
  if (isValueChanged) return true;
  return false;
};
